import React, { useState } from "react"
import withStyles from "@material-ui/styles/withStyles"

import { Button, FormHelperText, Input, Typography } from "@material-ui/core"
import Wrapper from "../../../components/Common/Wrapper"
import { userTypes } from "../../../Constants"
import { AccountBox } from "@material-ui/icons"
import { auth } from "../../../config/rebase"
import { ERROR_MESSAGES } from "../../../utils"
import CustomAlert from "../../../components/CustomAlert"
import CustomCardItemIcon from "../../../components/Cards/CustomCardItemIcon"

const styles = theme => ({
    paper: {
        margin: '10px',
        padding: theme.spacing(3),
        textAlign: "left",
        color: theme.palette.text.secondary
    },
    root: {
        flexGrow: 1,
        marginTop: '72px',
    },
    grid: {
        width: 1200,
        marginTop: 40,
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 20px)"
        }
    },
    rangeLabel: {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: theme.spacing(2)
    },
    topBar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 32
    },
    outlinedButtom: {
        textTransform: "uppercase",
        margin: theme.spacing(1)
    },
    actionButtom: {
        textTransform: "uppercase",
        margin: theme.spacing(1),
        width: 152
    },
    blockCenter: {
        padding: theme.spacing(2),
        textAlign: "center"
    },
    block: {
        padding: theme.spacing(2)
    },
    box: {
        marginBottom: 40,
        height: 65
    },
    inlining: {
        display: "inline-block",
        marginRight: 10
    },
    buttonBar: {
        display: "flex"
    },
    alignRight: {
        display: "flex",
        justifyContent: "flex-end"
    },
    noBorder: {
        borderBottomStyle: "hidden"
    },
    loadingState: {
        opacity: 0.05
    },
    loadingMessage: {
        position: "absolute",
        top: "40%",
        left: "40%"
    }
})

const Profile = ({ user, location }) => {

    const [loaded, setLoaded] = useState(true)
    const [passwordInputs, setPasswordInputs] = useState(false)

    const [error, setError] = useState(false)
    const [fatalError, setFatalError] = useState(false)
    const [success, setSuccess] = useState(false)

    const [newPass, setNewPass] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [oldPassword, setOldPassword] = useState('')

    const changePass = async (e) => {
        e.preventDefault()
        setLoaded(false)
        setSuccess(false)
        setError(false)
        setPasswordInputs(false)
        
        try {
            if (newPass !== confirmPassword) {
                return setError('Senhas não conferem')
            }

            if (newPass.length < 8) {
                return setError('Sua senha deve ter no mínimo oito caracteres')
            }

            const authCred = auth.EmailAuthProvider.credential(auth.currentUser.email, oldPassword)
            await auth.currentUser.reauthenticateWithCredential(authCred)
            await auth.currentUser.updatePassword(newPass)

            setSuccess("Senha atualizada com sucesso!")

        } catch (error) {
            console.log(error)
            const knownError = ERROR_MESSAGES.find(e => e.code === error.code)
            if (knownError) {
                return setError(knownError.translate)
            }
            setFatalError("Ocorreu um erro...")
        } finally {
            setLoaded(true)
        }
    }

    return (
        <Wrapper fatalError={fatalError} error={error} currentPath={location.pathname} footer={false} loaded={loaded} subscribedTopbar>
            <CustomAlert message={success} severity="success" />
            <CustomCardItemIcon icon={<AccountBox />}>
                <Typography component="span" variant="body1" gutterBottom>
                    Nome: {user.uName}
                </Typography>
                <br />
                <Typography component="span" variant="body1" gutterBottom>
                    E-mail: {user.uEmail}
                </Typography>
                <br />
                <Typography component="span" variant="body1" gutterBottom>
                    CPF: {user.ucpf}
                </Typography>
                <br />
                <Typography component="span" variant="body1" gutterBottom>
                    Tipo de Usuário: {userTypes.find(u => u.value === user.type).title}
                </Typography>
                <br />
                {
                    passwordInputs && (
                        <form onSubmit={changePass}>
                            <Input
                                placeholder="Antiga Senha"
                                type="password"
                                id="oldPassword"
                                name="oldPassword"
                                aria-describedby="oldPassword-helper"
                                required
                                onChange={v => setOldPassword(v.target.value)}
                                value={oldPassword}
                            />
                            <FormHelperText id="confirmPassword-helper">Insira sua antiga senha</FormHelperText>

                            <Input
                                placeholder="Nova Senha"
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                aria-describedby="confirmPassword-helper"
                                required
                                onChange={v => setConfirmPassword(v.target.value)}
                                value={confirmPassword}
                            />
                            <FormHelperText id="confirmPassword-helper">Insira sua nova senha</FormHelperText>

                            <Input
                                placeholder="Confirme sua Senha Nova"
                                type="password"
                                id="newpass"
                                name="newpass"
                                aria-describedby="newpass-helper"
                                required
                                onChange={v => setNewPass(v.target.value)}
                                value={newPass}
                            />
                            <FormHelperText id="newpass-helper">Insira a mesma senha</FormHelperText>
                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Trocar Senha
                                    </Button>
                        </form>
                    )
                }
                {
                    !passwordInputs && (
                        <Button fullWidth variant="contained" color="primary" onClick={() => setPasswordInputs(true)}>
                            Alterar Senha
                        </Button>
                    )
                }
            </CustomCardItemIcon>
        </Wrapper>
    );
}

export default withStyles(styles)(Profile)
